<template>
  <v-dialog v-model="showDownloadHistoryModal" persistent max-width="1000" content-class="requestModal">
    <v-card width="1530" class="d-flex flex-column overflow-y-auto">
      <v-sheet height="60" width="100%" color="primary" class="d-flex align-center">
        <h1 class="white--text title">Histórico de download</h1>
      </v-sheet>
      <v-data-table
        class="invoicingTable vtable-scroll-x"
        hide-default-footer
        mobile-breakpoint="0"
        :items-per-page="pagination.downloadHistories.size"
        :footer-props="{
          'items-per-page-text': 'Linhas por página',
          'first-icon': 'mdi-chevron-up',
          'page-text': '',
          'items-per-page-options': [10, 25, 50, 100],
        }"
        :headers="headers"
        :height="invoicingTableHeight"
        :items="pagination.downloadHistories"
        :page="pagination.downloadHistories.page"
        :server-items-length="pagination.downloadHistories.length"
      >
        <template v-for="header in defaultHeaderColumns" v-slot:[`header.${header.id}`]="{}">
          <HeaderCell :key="header.id" :id="header.id" :title="header.title" :headerClass="headerFirstLineClass" :headerStyle="headerFirstLine.style" />
        </template>

        <template v-slot:footer="{ props }">
          <v-container fluid class="px-0 pt-0">
            <v-divider />
            <v-row justify="end" class="d-flex flex-row align-center fill-height px-8 pt-2" style="height: 70px">
              <div class="d-flex flex-row align-center fill-height">
                <span style="margin-right: 50px" :class="labelFooter.class" :style="labelFooter.style"> Linhas por página </span>

                <v-select :value="pagination.size" :items="props.itemsPerPageOptions" hide-details dense class="footerSelectItemsPerPage primary--text mt-0" color="primary" :style="selectFooter.style" append-icon="mdi-chevron-down" @change="setSize" />
              </div>

              <span v-if="pagination.downloadHistories.length" :class="labelFooter.class" :style="labelFooter.style">
                {{ rangePagination }}
              </span>

              <v-btn icon :disabled="pagination.page === 0" @click="setPreviousPage">
                <v-icon size="24" color="primary"> mdi-chevron-left </v-icon>
              </v-btn>

              <v-btn icon :disabled="(pagination.page + 1) * props.pagination.itemsPerPage >= props.pagination.itemsLength" @click="setNextPage">
                <v-icon size="24" color="primary"> mdi-chevron-right </v-icon>
              </v-btn>
            </v-row>
          </v-container>
        </template>
      </v-data-table>

      <v-card-actions style="padding-right: 30px; padding-bottom: 30px;">
        <v-spacer></v-spacer>

        <v-btn outlined color="primary" style="width: 124px; height: 50px; border-radius: 5px;"@click="closeModal"> Fechar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import moment from "moment";
import HeaderCell from "../HeaderCell.vue";
import invoicingMixin from "@/shared/mixins/invoicing/invoicingMixin";

export default {
  name: "DownloadHistoryModal",

  components: {
    HeaderCell,
  },

  props: {
    invoicingId: {
      type: Number,
    },
  },

  data: () => ({
    rule: null,
    internalCriticisms: [],
    movementRecordId: null,
    documentsLoaded: false,
    isLoadingFile: false,
    showData: false,
    moment,
    pagination: {
      downloadHistories: [],
      page: 0,
      size: 25,
    },
    defaultHeaderColumns: [
      { id: "fileName", title: "Anexo" },
      { id: "userName", title: "Responsável" },
      { id: "downloadDate", title: "Data/Hora do Download" },
    ],
  }),

  mixins: [invoicingMixin],

  methods: {
    ...mapActions({
      fetchMajorities: "invoicing/fetchDownloadHistoryByInvoicing",
    }),

    ...mapMutations({
      loadingPage: "invoicing/loadingPage",
      setShowDownloadHistoryModal: "invoicing/setShowDownloadHistoryModal",
    }),

    setPreviousPage() {
      this.pagination.page -= 1;
    },
    setNextPage() {
      this.pagination.page += 1;
    },
    closeModal() {
      this.setShowDownloadHistoryModal(false);
    },

    showMessage(statusMessage, message) {
      const majoritySnackbar = this.majorityViewReference()?.$refs.MajoritySnackbar || false;

      majoritySnackbar.open(statusMessage, message);
    },
    setSize(size) {
      this.pagination.size = size;
    },
  },

  computed: {
    ...mapGetters({
      showDownloadHistoryModal: "invoicing/showDownloadHistoryModal",
    }),
    headers() {
      return [
        { value: "fileName", sortable: false },
        { value: "userName", sortable: false },
        { value: "downloadDate", sortable: false },
      ];
    },
    invoicingTableHeight() {
      const viewportHeight = window.innerHeight;
      const tableHeight = -560 + viewportHeight;
      const isFullScreen = tableHeight <= 1080;
      const hasMoreThanTen = this.hrProtectedInvoices && this.hrProtectedInvoices.length >= 10;

      if (!hasMoreThanTen) return null;
      if (!isFullScreen) return 455;
      return tableHeight < 400 ? 400 : tableHeight;
    },
    headerFirstLineClass() {
      return this.$vuetify.breakpoint.mdAndDown ? `${this.headerFirstLine.class} platformXippTable` : this.headerFirstLine.class;
    },
  },
};
</script>

<style>
.requestModal {
  max-height: 850px !important;
}

.title {
  font-size: 24px;
  margin-left: 30px;
}
.invoicingTable {
  margin: 50px 30px;
  border-radius: 5px !important;
  box-shadow: 0px 2px 6px #1a1f2626 !important;

  > .v-data-table__wrapper {
    border-radius: 5px 5px 0px 0px !important;

    > table {
      > .v-data-table-header {
        border-radius: 5px 5px 0px 0px !important;
        background-color: var(--v-ternary-base) !important;

        > tr {
          max-height: 90px;
          border-radius: 5px !important;

          > th {
            padding: 0 1% !important;
            background: var(--v-ternary-base) !important;

            > span {
              color: white !important;
            }
          }
        }
      }

      > tbody > tr {
        max-height: 70px;

        > td {
          padding: 0 1% !important;
        }
      }
    }
  }
}
</style>
